import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AssessRequestsComponent } from '../assess-requests/assess-requests.component';
import { SharedModule } from '../common/shared.module';
import { AssessRequestsRoutingModule } from './assess-requests-routing.module';
import { SelectRecipeComponent } from './select-recipe/select-recipe.component';
import { CreateRequestComponent } from './create-request/create-request.component';
import { SubmitRequestComponent } from './submit-request/submit-request.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { SelectRecipePlmComponent } from './select-recipe-plm/select-recipe-plm.component';
import { CreateRequestNonplmComponent } from './create-request-nonplm/create-request-nonplm.component';
import { SubmitRequestNonplmComponent } from './submit-request-nonplm/submit-request-nonplm.component';
import { CreateRequestWarningPopupComponent } from './create-request/create-request-warning-popup/create-request-warning-popup.component';
@NgModule({
  imports: [
    CommonModule,
    AssessRequestsRoutingModule,
    SharedModule,
    CKEditorModule,
  ],
  declarations: [
    AssessRequestsComponent,
    SelectRecipeComponent,
    CreateRequestComponent,
    SubmitRequestComponent,
    SelectRecipePlmComponent,
    CreateRequestNonplmComponent,
    SubmitRequestNonplmComponent,
    CreateRequestWarningPopupComponent
  ],
})
export class AssessRequestsModule { }
